// extracted by mini-css-extract-plugin
export default {"body":"MessageFeedbackModal-module__body--d1a0e","footer":"MessageFeedbackModal-module__footer--dfbfb Modals-module__footer--e47b9"};